import {
  IconButton,
  TableCell,
  TableRow,
  styled,
  Tooltip,
} from "@mui/material";
import React from "react";
import { ReactComponent as Pencil } from "../../../assets/svg/pencil.svg";
import customColors from "../../../styles/coreStyles/ColorPalette";
import FlashErrorIcon from "../../ErrorManager/ErrorIcon";
import { setError } from "../../../redux/slice/bookingSlice";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../redux/types/rootState";
import { IBooking, SelectedBooking } from "../../../api/bookings/IBookings";
import { overwriteDate } from "../../../mappers/mockAndRandomGenerateData";
import shortenString from "../Utils/stringShorter";

interface IClasses {
  TableCellBody: string;
  checkboxForCells: string;
}

const MyStyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(odd)": {
    backgroundColor: customColors.whiteHover,
  },
}));

// eslint-disable-next-line react/display-name
const MyRow = React.memo(
  ({
    row,
    handleEditClick,
    handleCheckClick,
    classes,
  }: {
    row: IBooking;
    handleEditClick: (clickedRowData: IBooking) => void;
    classes: IClasses;
    handleCheckClick: (checked: boolean) => void;
  }) => {
    const dispatch = useDispatch();
    const selectedBookings = useSelector(
      (state: RootState) => state.bookings.selectedBookings
    );
    function isBookingIdInArray(
      idToCheck: number,
      bookings: SelectedBooking[]
    ): boolean {
      return bookings.some((booking) => booking.id === idToCheck);
    }
    return (
      <MyStyledTableRow key={row.status}>
        <TableCell className={classes.TableCellBody}>
          <input
            type="checkbox"
            className={classes.checkboxForCells}
            onChange={(event) => handleCheckClick(event.target.checked)}
            checked={isBookingIdInArray(row.id!, selectedBookings)}
            disabled={row.status?.toUpperCase() !== "NEW"}
          />
        </TableCell>
        <TableCell className={classes.TableCellBody} component="th" scope="row">
          {row.status}
        </TableCell>
        <TableCell className={classes.TableCellBody}>
          {row.plateNumber /**unitNumber */}
        </TableCell>
        <TableCell className={classes.TableCellBody}>
          {shortenString({ inputString: row.iluCode, maxLength: 11 })}
        </TableCell>
        <TableCell className={classes.TableCellBody}>
          {row.adr ? "Yes" : "No"}
        </TableCell>
        <TableCell className={classes.TableCellBody}>
          {row.ferryVoyage.vessel.name}
        </TableCell>
        <TableCell className={classes.TableCellBody}>
          {overwriteDate(row.ferryVoyage.scheduledArrivalUtc) /*arrivalDate*/}
        </TableCell>
        <TableCell className={classes.TableCellBody}>
          {
            shortenString({
              inputString: row.customer.name,
              maxLength: 20,
            }) /*customerName*/
          }
        </TableCell>
        <TableCell className={classes.TableCellBody}>
          {row.customerNote}
        </TableCell>
        <TableCell className={classes.TableCellBody}>{row.pod}</TableCell>
        <TableCell className={classes.TableCellBody + " actionCell"}>
          <IconButton
            onClick={() => handleEditClick(row)}
            color="secondary"
            aria-label="edit booking"
            className="editButton"
          >
            <Pencil className="pencilIcon" />
          </IconButton>
          {row.bookingValidations && row.bookingValidations.length > 0 ? (
            <Tooltip
              title={
                <div>
                  {row.bookingValidations.map((validation, index) => (
                    <div key={index}>{validation}</div>
                  ))}
                </div>
              }
              placement="bottom"
              PopperProps={{
                modifiers: [
                  {
                    name: "offset",
                    options: {
                      offset: [0, -10], // Tooltip'i yukarı taşır
                    },
                  },
                ],
              }}
              arrow
            >
              <span className="error-icon-container">
                <FlashErrorIcon
                  onClick={() => {
                    dispatch(
                      setError({
                        // bookingId: row.id!,
                        validation: row.bookingValidations as string[],
                        title: "Validation Error",
                        details:
                          "Go back to the booking form and review all cargo-related fields. Ensure that each field is filled out with valid and complete information.",
                      })
                    );
                  }}
                />
              </span>
            </Tooltip>
          ) : (
            <></>
          )}
        </TableCell>
      </MyStyledTableRow>
    );
  }
);

export default MyRow;
